import type { IContextQueryResult } from '@modules/core/services/query/types';
import { AFFILIATE_PROGRAM_PROMO_CODES_PERMISSIONS } from '@modules/affiliate-program-promo-codes/constants';
import { useRestClient } from '@modules/core/services/api';
import { useContextQuery } from '@modules/core/services/query';
import { keepPreviousData } from '@tanstack/vue-query';

import type { IAffiliateProgramPromoListTrackersResponse } from '../types';
import {
  AFFILIATE_PROGRAM_PROMO_TRACKERS_LIST_API_URL,
  AFFILIATE_PROGRAM_PROMO_TRACKERS_LIST_QUERY_KEY,
} from '../constants';

export default function useAffiliateProgramPromoTrackersListQuery(): IContextQueryResult<
  IAffiliateProgramPromoListTrackersResponse,
  Error
> {
  const { fetchGet } = useRestClient();

  return useContextQuery<IAffiliateProgramPromoListTrackersResponse>({
    queryKey: [AFFILIATE_PROGRAM_PROMO_TRACKERS_LIST_QUERY_KEY],
    queryFn: ({ signal }) => fetchGet<IAffiliateProgramPromoListTrackersResponse>(
      AFFILIATE_PROGRAM_PROMO_TRACKERS_LIST_API_URL,
      {
        signal,
        permission: AFFILIATE_PROGRAM_PROMO_CODES_PERMISSIONS.CREATE,
      },
    ),
    placeholderData: keepPreviousData,
  });
}
